var Orientation={top:"top",left:"left",right:"right",bottom:"bottom"};export default Orientation;